import { HTMLAttributes, ReactNode } from "react";

export const SummaryList = ({ children }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div>
      {children}
    </div>
  )
}

type SummaryListRowProps = HTMLAttributes<HTMLDivElement> & {
  label: ReactNode;
  value?: ReactNode;
  action?: ReactNode;
};

export const SummaryListRow = ({ label, value, action, children }: SummaryListRowProps) => {
  return (
    <div className="flex flex-col lg:flex-row gap-x-2 gap-y-1 border-b last:border-b-0 py-2 items-start lg:items-center">
      <label className="font-semibold lg:w-[25%] shrink-0">
        {label}
      </label>

      <div className="w-full grow">
        {value || children}
      </div>

      {action && (
        <div className="lg:min-w-[20%] px-4">
          {action}
        </div>
      )}
    </div>
  )
}
